import styled from 'styled-components';

export const StockMovementContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
  .amount_in {
    color: ${({ theme }) => theme.COLORS.GREEN_1};
  }
  .amount_out {
    color: ${({ theme }) => theme.COLORS.RED_1};
  }
  .backfill_tag {
    margin-left: 6px;
    padding: 1px 6px;
    border-radius: 4px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S11};
    background: ${({ theme }) => theme.COLORS.GRAY_1};
    color: ${({ theme }) => theme.COLORS.GRAY_3};
  }
`;
